import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heading } from '@/components/ui/heading';
import MessageList from '@/components/chat/MessageList';

type ToneProfile = {
  guidelines?: string[];
  examples?: { context: string; reply: string }[];
};

type Props = {
  profile: ToneProfile;
  submitting: boolean;
  onReset: () => void;
};

export function ToneDoneStep({ profile, submitting, onReset }: Props) {
  return (
    <Card className="p-6 space-y-4 shadow-sm">
      <div className="flex items-start gap-2">
        <div>
          <Heading level={3} className="flex items-center gap-2">
            Tone of voice attivo
            <Badge variant="default">Pronto</Badge>
          </Heading>
          <p className="text-muted-foreground">
            Il tuo stile verrà applicato a tutte le chat dei tuoi pazienti.
          </p>
        </div>
      </div>
      {profile?.guidelines && profile.guidelines.length > 0 ? (
        <div className="space-y-2">
          <Heading level={4}>Linee guida</Heading>
          <ul className="list-disc ml-5 space-y-1">
            {profile.guidelines.map((g, idx) => (
              <li key={idx}>{g}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {profile?.examples && profile.examples.length > 0 ? (
        <div className="space-y-2">
          <Heading level={4}>Esempi sintetici</Heading>
          <ul className="space-y-2">
            {profile.examples.map((ex, idx) => (
              <Card variant="elevated" key={idx}>
                <CardContent>
                  <MessageList
                    messages={[
                      {
                        id: 1,
                        role: 'user',
                        content: ex.context,
                        created_at: new Date().toISOString(),
                      },
                      {
                        id: 2,
                        role: 'assistant',
                        content: ex.reply,
                        created_at: new Date().toISOString(),
                      },
                    ]}
                    streamingMsg=""
                    copiedId={null}
                    assistantLabel="EmoviBot"
                  />
                </CardContent>
              </Card>
            ))}
          </ul>
        </div>
      ) : null}
      <div className="flex gap-3 justify-end">
        <Button variant="outline" disabled={submitting} onClick={onReset} isLoading={submitting}>
          {submitting ? 'Sto creando nuovi esempi...' : 'Ripeti addestramento'}
        </Button>
      </div>
    </Card>
  );
}
